var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 24 24",
    width: 44,
    height: 44,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "linkedin-square",
    d: "M6.47,17.39v-7.22h2.41v7.23H6.47V17.39z M8.66,8.83c-0.27,0.25-0.63,0.38-1,0.36l0,0  c-0.37,0.03-0.73-0.11-1-0.36C6.42,8.6,6.28,8.28,6.29,7.94C6.28,7.58,6.43,7.23,6.71,7c0.27-0.24,0.63-0.37,1-0.35  c0.37-0.03,0.73,0.1,1,0.35c0.24,0.24,0.38,0.56,0.37,0.9C9.09,8.26,8.93,8.6,8.66,8.83z M15.13,17.39v-3.86  c0-1.09-0.4-1.63-1.21-1.63c-0.28-0.01-0.55,0.08-0.77,0.26c-0.2,0.17-0.37,0.38-0.47,0.62c-0.06,0.19-0.08,0.38-0.07,0.58v4H10.2  c0-4.36,0-6.77,0-7.23h2.4v1.05l0,0c0.45-0.76,1.28-1.21,2.16-1.18c0.75-0.03,1.48,0.27,2,0.82c0.55,0.68,0.82,1.55,0.76,2.43v4.14  H15.13L15.13,17.39z M19.13,4.88C18.57,4.3,17.8,3.99,17,4H7C5.34,4,4,5.34,4,7v10c0,1.66,1.34,3,3,3h10c1.66,0,3-1.34,3-3V7  C20.01,6.2,19.69,5.44,19.13,4.88L19.13,4.88z",
    style: {
      fill: "rgb(255, 255, 255)"
    },
    vectorEffect: "non-scaling-stroke"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.7a0dad5b.svg";
export { ForwardRef as ReactComponent };